import { fieldMap2, typeMap2, unitMap, dataTypeMap,childFieldMap } from "@/constants/dataMap";
import towerJson from "@/Components/Diagram/elementsData/tower.json";
import heatExchanger from "@/Components/Diagram/elementsData/heatExchanger.json";
import MultiStreamExchanger from "@/Components/Diagram/elementsData/MultiStreamExchanger.json";

//逆向将input转为前端输入所需的格式
export const buildNodeDataByInput = (oldElementData:any,input:any,elementType:string,globalData:any) => 
{
    let elementData = structuredClone(oldElementData);
    let materials = globalData.materials;

    if(elementType==="node")    //元件
    {
        let nodeName = elementData.nodeName;
        let nodeType = elementData.type;

        // if(nodeName==="E-101")
        // {
        //     console.log("elementData:",elementData);
        //     console.log("input:",input);
        //     debugger
        // }

        let inputElement = input.elements.find(item=>item.name===nodeName); //此处使用==，因为可能存在值不为string的可能性

        if(inputElement)
        {
            //更新基础数据
            elementData.mode = inputElement.mode;
            elementData.phase = inputElement.phase;
            elementData.physical_method = inputElement.physical_method;
            elementData.isRun = inputElement.isRun;

            //更新参数
            let paramValues = elementData.ParamValues;
            let inputParams = inputElement.params;
            for (let fieldName in paramValues)
            {
                let engFieldName = paramValues[fieldName].engName;

                if(inputParams[engFieldName] || inputParams[engFieldName]===0 || engFieldName in inputParams)
                {
                    //能找到的参数，代表是显性参数

                    //某些字段可能因为名字重复的原因，满足了正常参数的条件，但是实际上并非正常参数
                    let isNormalField = true;
                    //特殊处理
                    if(nodeType === "MultiStreamExchanger" && elementData.elementName === "换热器4" && (engFieldName === "cold_out_T" || engFieldName === "cold_out_P" ||engFieldName === "hot_out_T" || engFieldName === "hot_out_P"))
                    {
                        isNormalField = false;
                    }

                    if(dataTypeMap[engFieldName] && (dataTypeMap[engFieldName]==="string"||dataTypeMap[engFieldName]==="number") && isNormalField)
                    {
                        //正常参数
                        let inputParamsValue = inputParams[engFieldName];
                        paramValues[fieldName].value = inputParamsValue;

                        //单位
                        if(paramValues[fieldName].unit)
                        {
                            //查找单位字段名
                            let unitFieldName = paramValues[fieldName].unitField??`${engFieldName}_unit`;
                            if(unitFieldName==="")
                            {
                                unitFieldName = `${engFieldName}_unit`;
                            }
                            if(inputParams[unitFieldName])
                            {
                                paramValues[fieldName].unit = inputParams[unitFieldName];
                            }
                        }
                    }
                    else
                    {
                        //其他类型参数

                        //子项
                        if(paramValues[fieldName].p_children)
                        {
                            let inputParamsChildren = inputParams[engFieldName];
                            let paramValuesChildren = [];

                            for(let i=0;i<inputParamsChildren.length;i++)
                            {
                                let inputParamsChild = inputParamsChildren[i];

                                let paramValuesChild = {};
                                for(let inputParamsChildField in inputParamsChild)
                                {
                                    paramValuesChild[childFieldMap?.[engFieldName]?.[inputParamsChildField].name??inputParamsChildField] =
                                    {
                                        "value":inputParamsChild[inputParamsChildField],
                                        "desValue":inputParamsChild[inputParamsChildField],
                                        "show": true,
                                        "engName":inputParamsChildField
                                    };
                                }
                                paramValuesChildren.push(paramValuesChild);
                            }

                            //特殊处理
                            if (nodeType === "DistilStrict" && engFieldName === "eff")
                            {
                                for(let i=0;i<paramValuesChildren.length;i++)
                                {
                                    if(paramValuesChildren[i]["特殊效率"].value.length>0)
                                    {
                                        let paramValuesChildrenChildren = [];
                                        for(let j=0;j<paramValuesChildren[i]["特殊效率"].value.length;j++)
                                        {
                                            let paramValuesChildrenChild = 
                                            {
                                                "组分":
                                                {
                                                    "value":materials[(paramValuesChildren[i]["特殊效率"].value[j][0])-1]?.name ?? paramValuesChildren[i]["特殊效率"].value[j][0],
                                                    "show": true,
                                                    "engName": "组分",
                                                    "readonly": true
                                                },
                                                "效率值":
                                                {
                                                    "value":paramValuesChildren[i]["特殊效率"].value[j][1],
                                                    "desValue":paramValuesChildren[i]["特殊效率"].value[j][1],
                                                    "show": true,
                                                    "engName": "效率值"
                                                }
                                            };
                                            paramValuesChildrenChildren.push(paramValuesChildrenChild);
                                        }
                                        paramValuesChildren[i]["特殊效率"].children = paramValuesChildrenChildren;
                                    }
                                    else
                                    {
                                        paramValuesChildren[i]["特殊效率"].show = false;
                                        paramValuesChildren[i]["特殊效率"].children = [];
                                    }
                                }
                            }
                            if (nodeType === "DistilStrict" && (engFieldName === "Ns" || engFieldName === "No"))
                            {
                                paramValuesChildren = [];
                                if(engFieldName === "Ns")
                                {
                                    for(let i=0;i<inputElement.inputStreams.length;i++)
                                    {
                                        let streamName = inputElement.inputStreams[i].name;
                                        let paramValuesChild = paramValues[fieldName].p_children.find(item=>item["流股"].value==streamName);
                                        if(paramValuesChild)
                                        {
                                            paramValuesChild["进料位置"].value = inputParamsChildren[i];
                                            paramValuesChild["进料位置"].desValue = inputParamsChildren[i];
                                            paramValuesChildren.push(paramValuesChild);
                                        }
                                    }
                                }
                                else if(engFieldName === "No")
                                {
                                    for(let i=0;i<inputElement.outputStreams.length;i++)
                                    {
                                        let streamName = inputElement.outputStreams[i].name;
                                        let paramValuesChild = paramValues[fieldName].p_children.find(item=>item["流股"].value===streamName);
                                        if(paramValuesChild)
                                        {
                                            paramValuesChild["出料位置"].value = inputParamsChildren[i];
                                            paramValuesChild["出料位置"].desValue = inputParamsChildren[i];
                                            paramValuesChildren.push(paramValuesChild);
                                        }
                                    }
                                }
                                
                            }
                            if (nodeType === "Splitter" && engFieldName === "output_f")
                            {
                                paramValuesChildren = [];
                                
                                for(let i=0;i<inputElement.outputStreams.length;i++)
                                {
                                    let streamName = inputElement.outputStreams[i].name;
                                    let paramValuesChild = paramValues[fieldName].p_children.find(item=>item["流股"].value==streamName);
                                    if(paramValuesChild)
                                    {
                                        paramValuesChild["输出流量"].value = inputParamsChildren[i];
                                        paramValuesChild["输出流量"].desValue = inputParamsChildren[i];
                                        paramValuesChildren.push(paramValuesChild);
                                    }
                                }
                            }
                            if (nodeType === "MultiStreamExchanger" && (engFieldName === "cold_out_T" || engFieldName === "hot_out_T" || engFieldName === "cold_out_P" || engFieldName === "hot_out_P"))
                            {
                                paramValuesChildren = [];
                                let childFieldName = "";
                                if(engFieldName === "cold_out_T" || engFieldName === "hot_out_T")
                                {
                                    childFieldName = "出口温度";
                                }   
                                else if(engFieldName === "cold_out_P" || engFieldName === "hot_out_P")
                                {
                                    childFieldName = "出口压力";
                                }

                                for(let i=0;i<inputElement.outputStreams.length;i++)
                                {
                                    let streamName = inputElement.outputStreams[i].name;
                                    if(paramValues[fieldName].p_children.length===0)   //代表没有对应流股，因为该数据是从图上取的，存在图上没有关联关系，但是后续在任务中建立关系的可能性
                                    {
                                        for(let j=0;j<inputElement.outputStreams.length;j++)
                                        {
                                            if(fieldName.includes(inputElement.outputStreams[j].streamAttribute))
                                            {
                                                let p_childFieldName = fieldName.includes("出口温度")?"出口温度":"出口压力";
                                                let p_child = {};
                                                p_child[p_childFieldName] = 
                                                {
                                                    engName:p_childFieldName,
                                                    show:true,
                                                };
                                                p_child["流股"] = 
                                                {
                                                    engName:"streamName",
                                                    show:true,
                                                    readonly:true,
                                                    value:inputElement.outputStreams[j].name,
                                                    desValue:inputElement.outputStreams[j].name,
                                                };
                                                paramValues[fieldName].p_children.push(p_child);
                                            }
                                        }
                                    }
                                    let paramValuesChild = paramValues[fieldName].p_children.find(item=>item["流股"].value==streamName);
                                    if(paramValuesChild)
                                    {
                                        //if(inputParamsChildren[i])
                                        if(true)
                                        {
                                            paramValuesChild[childFieldName].value = inputParamsChildren[i];
                                            paramValuesChild[childFieldName].desValue = inputParamsChildren[i];
                                            paramValuesChild[childFieldName].unit = inputParams[childFieldName==="出口压力"?"p_unit":"t_unit"];
                                            paramValuesChildren.push(paramValuesChild);
                                        }
                                    }
                                }
                            }
                            if (nodeType === "ShellAndTubeExchanger" && engFieldName === "stream_type")
                            {
                                let paramValuesChild = {};
                                for(let inputParamsChildrenEngField in inputParamsChildren)
                                {
                                    let inputParamsChildrenField = childFieldMap[engFieldName][inputParamsChildrenEngField].name;
                                    paramValuesChild[inputParamsChildrenField] = 
                                    {
                                        "value":inputParamsChildren[inputParamsChildrenEngField],
                                        "desValue":inputParamsChildren[inputParamsChildrenEngField],
                                        "show": true,
                                        "engName":inputParamsChildrenEngField
                                    };
                                }
                                paramValuesChildren = [paramValuesChild];
                            }
                            paramValues[fieldName].p_children = paramValuesChildren;
                        }
                    }

                    //显性参数，show设为true
                    paramValues[fieldName].show = true;

                    //但存在一部分始终不显示，但input中的确也存在的数，进行特殊处理
                    if(
                        (nodeType==="DistilStrict" && (engFieldName==="type" || engFieldName==="murphree" || engFieldName==="max_iter_outer" || engFieldName==="max_iter_inner" || engFieldName==="max_notimproved_count" || engFieldName==="max_inner_notconverged_count" || engFieldName==="TOL" || engFieldName==="INNER_TOL"|| engFieldName==="im_mode" || engFieldName==="h" || engFieldName==="T_drop" || engFieldName==="S1")) ||
                        (nodeType==="Flash2" && (engFieldName==="type" || engFieldName==="type") ||
                        (nodeType==="ShellAndTubeExchanger" && engFieldName==="stream_type") )
                    )
                    {
                        paramValues[fieldName].show = false;
                    }
                }
                else
                {
                    //不能找到的参数，代表是隐形参数
                    //原值不变(因为找不到)但是show设为false
                    paramValues[fieldName].show = false;
                }
            }
            elementData.ParamValues = paramValues;
        }
    }
    else if(elementType==="link")   //流股
    {
        let linkName = elementData.linkName;

        let inputElement = input.streams.find(item=>item.name==linkName);   //此处使用==，因为可能存在值不为string的可能性

        if(inputElement)
        {
            //更新参数
            let paramValues = elementData.ParamValues;
            let inputParams = inputElement.params;
            for (let fieldName in paramValues)
            {
                let engFieldName = paramValues[fieldName].engName;

                if(inputParams[engFieldName] || inputParams[engFieldName]===0)
                {
                    //能找到的参数，代表是显性参数

                    if(dataTypeMap[engFieldName] && (dataTypeMap[engFieldName]==="string"||dataTypeMap[engFieldName]==="number"))
                    {
                        //正常参数
                        let inputParamsValue = inputParams[engFieldName];
                        paramValues[fieldName].value = inputParamsValue;

                        //单位
                        if(paramValues[fieldName].unit)
                        {
                            //查找单位字段名
                            let unitFieldName = paramValues[fieldName].unitField??`${engFieldName}_unit`;
                            if(unitFieldName==="")
                            {
                                unitFieldName = `${engFieldName}_unit`;
                            }
                            if(inputParams[unitFieldName])
                            {
                                paramValues[fieldName].unit = inputParams[unitFieldName];
                            }
                        }
                    }

                    //显性参数，show设为true
                    paramValues[fieldName].show = true;
                }
                else
                {
                    //不能找到的参数，代表是隐形参数
                    //原值不变(因为找不到)但是show设为false
                    paramValues[fieldName].show = false;
                }
            }

            //更新组分
            let materials = {};
            let inputMaterials = inputElement.materials;
            let elementMaterials = elementData.materials;
            for(let i=0;i<inputMaterials.length;i++)
            {
                let inputMaterial = inputMaterials[i];
                let elementMaterial = elementMaterials[inputMaterial.name];
                if(elementMaterial)
                {
                    elementMaterial.molar_frac = inputMaterial.molar_frac;
                    elementMaterial.desValue = inputMaterial.molar_frac;
                }
                else
                {
                    //如果没找到按说也应该加进来，但是此时两处组分数据应该必定相等，所以无需添加分支
                }
                materials[inputMaterial.name] = elementMaterial;
            }

            elementData.ParamValues = paramValues;
            elementData.materials = materials;
            elementData.isRun = inputElement.isRun;
        }
    }
    
    return elementData;
};
